
import React from 'react';
import axios from 'axios';
import { Form, Upload, Button, message, Radio, Input } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';

class ClientServiecFormInit extends React.Component {
    state = {
        fileList: [],
        submitting: false
    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken';
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
        axios.defaults.headers = {
            "Content-Type": 'multipart/form-data', //"application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.handleFormSubmit(
                    values,
                    e,
                )
                console.log('Received values of form: ', values);
            }
        });
    }

    handleFormSubmit = (values, event) => {
        this.setState({
            submitting: true
        });

        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('files', file);
        });

        formData.append('name', values.name);
        formData.append('reason', values.reason);
        formData.append('message', values.message);
        formData.append('service_detail', this.props.service_detail_id);
        // const postObj = {
        //     service_detail: this.props.service_detail_id,
        //     name: values.name,
        //     type: values.type,
        //     message: values.message,
        //     files: formData
        // }

        axios.post(process.env.REACT_APP_AXIOS_URL + "/api/service/request/create/", formData)
            .then(res => {
                if (res.status === 201) {
                    this.props.form.resetFields();
                    message.success(this.props.t('clients.client_service_form.message_sent', "Message sent"));
                    this.setState({
                        fileList: [],
                        submitting: false
                    });
                    // this.props.history.push(`/`);
                }
            }).catch(error => {
                this.setState({
                    submitting: false
                });
            });
    };


    render() {
        const { getFieldDecorator } = this.props.form;
        const { uploading, fileList } = this.state;
        const { t } = this.props;

        const uploader = {
            // name: 'file',
            // multiple: true,
            // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            // custommRequest(info) {
            //     console.log(info);
            //     this.setState({ 'uploadedFiles': info.fileList });
            // },

            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            // beforeUpload: file => {
            //     this.setState(state => ({
            //         fileList: [...state.fileList, file],
            //     }));
            //     return false;
            // },
            beforeUpload: file => {
                message.warning(this.props.t('clients.client_service_form.only_one_file', "Only one file is allowed for now!"))
                this.setState({
                    fileList: [file],
                });
                return false;
            },
            fileList,

            // onChange(info) {
            //     // const { status } = info.fileList;
            //     this.setState({ 'uploadedFiles': info.fileList });
            //     // console.log(info);
            //     // // this.setState({ 'selectedFiles': files });
            //     // if (status !== 'uploading') {
            //     //     console.log(info.file, info.fileList);
            //     // }
            //     // if (status === 'done') {
            //     //     message.success(`${info.file.name} file uploaded successfully.`);
            //     // } else if (status === 'error') {
            //     //     message.error(`${info.file.name} file upload failed.`);
            //     // }
            // },
        };

        return (
            <div>
                <h3>{t('clients.client_service_form.request_changes', "Request changes or leave a new message")}</h3>
                <Form hideRequiredMark onSubmit={this.handleSubmit}>
                    <Form.Item label={t('clients.client_service_form.name', "Meesage name")}>
                        {getFieldDecorator('name', {
                            rules: [{
                                required: true, message: t('clients.client_service_form.name_required', "Name for your message is required")
                            }],
                        })(<Input name="name" />)}
                    </Form.Item>
                    <Form.Item label={t('clients.client_service_form.reason', "Message reason")}>
                        {getFieldDecorator('reason', {
                            rules: [{
                                required: true, message: t('clients.client_service_form.reason_required', "Message reason is required")
                            }],
                        })(<Radio.Group name="reason" buttonStyle="solid">
                            <Radio.Button value="modification">{t('clients.client_service_form.modification', "Modification")}</Radio.Button>
                            <Radio.Button value="question">{t('clients.client_service_form.question', "Question")}</Radio.Button>
                            <Radio.Button value="dissatisfaction">{t('clients.client_service_form.dissatisfaction', "Dissatisfaction")}</Radio.Button>
                            <Radio.Button value="other">{t('clients.client_service_form.other', "Other")}</Radio.Button>
                        </Radio.Group>)}
                    </Form.Item>
                    <Form.Item label={t('clients.client_service_form.message', "Message")}>
                        {getFieldDecorator('message', {
                            rules: [{
                                required: true, message: t('clients.client_service_form.message_required', "Message is required")
                            }],
                        })(<Input.TextArea name="message" autoSize />)}
                    </Form.Item>
                    <Form.Item label={t('clients.client_service_form.images', "Images")}>
                        <Form.Item>
                            <Upload.Dragger {...uploader} >
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">{t('clients.client_service_form.images_upload_1', "Click or drag file to this area to upload")}</p>
                                <p className="ant-upload-hint">{t('clients.client_service_form.images_upload_2', "Support for a single or bulk upload.")}</p>
                            </Upload.Dragger>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={this.state.submitting}>
                            {t('clients.client_service_form.submit', "Submit")}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}


const ClientServiceForm = Form.create()(withTranslation()(ClientServiecFormInit));
export default ClientServiceForm;


// WEBPACK FOOTER //
// ./src/containers/ClientZone/ClientServiceForm.js